<input pInputText #inputElement
	[id]="widget.uid"
    [hisDdKey]="widget.label"
    [hisDdSearchCriterion]="true"
    [(ngModel)]="widget.value"
    [type]="widget.type"
    style="width: 100%;"
    (input)="change(widget.value)"
    [placeholder]="getPlaceholder() | hisUi"
    autocomplete="on"
/>
